import moment from 'moment';

export default function(time) {
  if (!time) return '';
  const dt = moment.utc(time);
  if (!dt.isValid()) return '';
  return dt.local().format('L LT');
}
